import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-0 p-[20px] md:p-[25px] rounded-md h-full flex flex-col" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0 text-md font-medium" }
const _hoisted_5 = { class: "trezo-card-content flex-grow flex flex-col" }
const _hoisted_6 = { class: "relative mb-[20px]" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "flex-grow" }
const _hoisted_9 = { class: "chat-users-list overflow-y-scroll chat-sidebar-height ltr:-mr-[5px] rtl:-ml-[5px] md:ltr:-mr-[10px] md:rtl:-ml-[10px] ltr:pr-[20px] rtl:pl-[20px] md:ltr:pr-[25px] md:rtl:pl-[25px]" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "relative ltr:mr-[10px] rtl:ml-[10px]" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "block font-semibold text-black dark:text-white" }
const _hoisted_15 = { class: "text-xs block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('chat.messages')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", _hoisted_6, [
        _cache[0] || (_cache[0] = _createElementVNode("label", { class: "absolute ltr:left-[13px] rtl:right-[13px] mt-[2px] text-black dark:text-white top-1/2 -translate-y-1/2" }, [
          _createElementVNode("i", { class: "material-symbols-outlined !text-lg" }, " search ")
        ], -1)),
        _createElementVNode("input", {
          type: "text",
          class: "block w-full rounded-md text-black dark:text-white bg-gray-50 dark:bg-[#15203c] border border-gray-50 dark:border-[#15203c] focus:border-primary-500 h-[40px] outline-0 transition-all text-xs placeholder:text-gray-500 dark:placeholder:text-gray-400 ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[15px] rtl:pl-[15px]",
          placeholder: _ctx.directT('chat.search')
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatList, (chat, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex items-center justify-between mb-[13.5px] pb-[13.5px] border-b border-gray-100 dark:border-[#172036] last:border-0 last:pb-0 last:mb-0 cursor-pointer hover:bg-gray-50 dark:hover:bg-[#15203c] transition-colors p-2 rounded-md",
              onClick: ($event: any) => (_ctx.selectChat(chat))
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    src: chat.profile_picture_url || _ctx.defaultProfileImage,
                    alt: "user-image",
                    class: "rounded-full w-[35px]"
                  }, null, 8, _hoisted_13),
                  _createElementVNode("span", {
                    class: _normalizeClass(["absolute ltr:right-0 rtl:left-0 bottom-0 w-[10px] h-[10px] rounded-full", [
                    chat.status === 'online' ? 'bg-success-500' : chat.status === 'away' ? 'bg-orange-400' : 'bg-gray-400',
                    'border-[2px] border-white dark:border-[#0c1427]'
                  ]])
                  }, null, 2)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(chat.name || chat.phone), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["block text-xs mt-[2px]", { 'text-success-600': chat.typing }])
                  }, _toDisplayString(chat.typing ? _ctx.directT('chat.typing') : chat.lastMessage), 3)
                ])
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(chat.time), 1)
            ], 8, _hoisted_10))
          }), 128))
        ])
      ])
    ])
  ]))
}